/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/. */
// Parse a comma-separated list with allowance for varied whitespace
export function commaSeparatedListToArray(s) {
    return (s || '')
        .trim()
        .split(',')
        .map((c) => c.trim())
        .filter((c) => !!c);
}
